<div class="wrapper">
    <div class="not-found">
        No results found
    </div>
    <div class="tip">
        Try adjusting your search or filter to find what you’re looking for.
    </div>
</div>